// extracted by mini-css-extract-plugin
module.exports = {"padding":"NotEditableModal_padding__UZvWC","body":"NotEditableModal_body__ZEpY_"};